import { FC, useEffect, useState } from "react";
import { Box, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useRequestDownloadFileFn, useRequests } from "../../api";
import { PdfViewer } from "../../components/PdfViewer";

interface CandidateDetailsPdfViewerModalProps {
    isOpen: boolean;
    onClose: () => void;
    documentId: string | undefined;
}

export const CandidateDetailsPdfViewerModal: FC<CandidateDetailsPdfViewerModalProps> = ({ isOpen, onClose, documentId }) => {
    const downloadFileFn = useRequestDownloadFileFn();
    const { cId, eId, candidateId } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [pdfData, setPdfData] = useState<Blob>();
    const requestsQuery = useRequests(cId, eId, candidateId);
    const requests = requestsQuery.data || [];
    const request: any = requests.find((r: any) => r.documents?.some((d: any) => d.id === documentId)) || { documents: [] };
    const document: any = request.documents.find((d: any) => d.id === documentId);
    const progressCallback = (progress: number) => {
        setIsLoading(progress < 100);
    };

    useEffect(() => {
        if (isOpen && documentId && !pdfData) {
            setTimeout(async () => {
                const result = await downloadFileFn(cId, eId, candidateId!, request.id, documentId!, progressCallback);
                setPdfData(result);
            }, 0);
        }
        if (!isOpen) {
            setPdfData(undefined);
            setIsLoading(true);
        }
    }, [isOpen, documentId]);

    // ---- Navigation Helper ----
    // (removed - now handled via onClose prop)

    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} size={"4xl"}>
                <ModalOverlay />
                <ModalContent minH="400pt" maxH="100vh" mt="10px">
                    <ModalHeader>View File</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={"1.5rem"}>
                        <Box mb={4}>
                            <h2>{document?.name}</h2>
                        </Box>
                        <Box>
                            <PdfViewer pdfData={pdfData} height="calc(100vh - 250px)" minH="233pt" boxShadow={"5px 5px 10px 5px rgb(0 0 0 / 30%)"} />
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Box display="flex" justifyContent="flex-end" gap={4} mt={4}>
                            <Button
                                as="a"
                                href={pdfData ? URL.createObjectURL(pdfData) : undefined}
                                download={document?.name}
                                title={document?.name}
                                variant={"primary"}
                                isDisabled={isLoading}
                                isLoading={isLoading}
                            >
                                Download file
                            </Button>
                            <Button onClick={onClose}>Cancel</Button>
                        </Box>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};
